export default __webpack_public_path__ + "static/media/agafonov.301eb3bd.png";